module.exports = __webpack_public_path__ + "static/media/services-icon2.c8f3c263.png";